angular.module('bribac.components.imageDetailModal', [
  'bribac.translations'
])

    .component('imageDetailModal', {
        templateUrl: 'image-detail-modal-component.html',
        controller: 'ImageDetailModalComponentCtrl',
        bindings: {
          modalInstance: '<',
          resolve: '<'
        }
    })

    .controller('ImageDetailModalComponentCtrl', function () {
      var $ctrl = this
    })
